
<template>
  <div></div>
</template>

<script>
    import { EventBus } from '@/event-bus.js';
  export default {
    name: 'MdTextSpeech',
    props: {
      
    },
    data() {
      return {
        isSpeechRecognitionSupported: false,
        recognition: null,
        recognizing : false,
        isSpeaking: false,
        replacements : {
            'es': [
                { regex: /\bpunto y coma\b/gi, value: ';' },
                { regex: /\bpunto\b/gi, value: '.' },
                { regex: /\bcoma\b/gi, value: ',' },
                { regex: /\bdos puntos\b/gi, value: ':' },
                { regex: /\bcomillas\b/gi, value: '"' },
                { regex: /\babrir comillas\b/gi, value: '"' },
                { regex: /\bcerrar comillas\b/gi, value: '"' },
                { regex: /\bparéntesis\b/gi, value: ')' },
                { regex: /\babrir paréntesis\b/gi, value: '(' },
                { regex: /\bcerrar paréntesis\b/gi, value: ')' },
                { regex: /\bguion\b/gi, value: '-' },
                { regex: /\bguion bajo\b/gi, value: '_' },
                { regex: /\binterrogación\b/gi, value: '?' },
                { regex: /\bsigno de interrogación\b/gi, value: '?' },
                { regex: /\bexclamación\b/gi, value: '!' },
                { regex: /\bsigno de exclamación\b/gi, value: '!' },
                { regex: /\bnueva línea\b/gi, value: '\n' },
                { regex: /\bnuevo párrafo\b/gi, value: '\n\n' }
            ],
            'en': [
                { regex: /\bsemicolon\b/gi, value: ';' },
                { regex: /\bperiod\b/gi, value: '.' },
                { regex: /\bcomma\b/gi, value: ',' },
                { regex: /\bcolon\b/gi, value: ':' },
                { regex: /\bquote\b/gi, value: '"' },
                { regex: /\bquotation marks\b/gi, value: '"' },
                { regex: /\bopen quote\b/gi, value: '"' },
                { regex: /\bclose quote\b/gi, value: '"' },
                { regex: /\bparenthesis\b/gi, value: ')' },
                { regex: /\bopen parenthesis\b/gi, value: '(' },
                { regex: /\bclose parenthesis\b/gi, value: ')' },
                { regex: /\bdash\b/gi, value: '-' },
                { regex: /\bhyphen\b/gi, value: '-' },
                { regex: /\bunderscore\b/gi, value: '_' },
                { regex: /\bquestion mark\b/gi, value: '?' },
                { regex: /\bexclamation mark\b/gi, value: '!' },
                { regex: /\bnew line\b/gi, value: '\n' },
                { regex: /\bnew paragraph\b/gi, value: '\n\n' },
                    // Entidades HTML para inglés
                { regex: /&#32;/g, value: ' ' },
                { regex: /&#33;/g, value: '!' },
                { regex: /&#34;/g, value: '"' },
                { regex: /&#35;/g, value: '#' },
                { regex: /&#37;/g, value: '%' },
                { regex: /&#44;/g, value: ',' },
                { regex: /&#45;/g, value: '-' },
                { regex: /&#46;/g, value: '.' },
                { regex: /&#47;/g, value: '/' },
                { regex: /&#39;/g, value: "'" }
            ]
        },
        speechRecognitionList: null,

      }
    },
    methods:{
        // Check if the browser supports Speech Recognition
        // and initialize the recognition object
        SpeechRecognition(){
            this.isSpeechRecognitionSupported = 'SpeechRecognition' in window || 'webkitSpeechRecognition' in window;
            if(this.isSpeechRecognitionSupported){
                window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
                this.recognition = new window.SpeechRecognition();

                const SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList;
                // Gramáticas para cada idioma
                const grammarEs = `#JSGF V1.0;grammar puntuacion;public <command> = punto y coma |punto |coma |dos puntos |
                                        comillas | abrir comillas | cerrar comillas | paréntesis | abrir paréntesis |
                                        cerrar paréntesis | guion | guion bajo | interrogación | signo de interrogación |
                                        exclamación | signo de exclamación | nueva línea | nuevo párrafo ;`;

                const grammarEn = `#JSGF V1.0; grammar punctuation; public <command> = semicolon |
                                    period | comma | colon | quote | quotation marks | open quote | close quote |
                                    parenthesis | open parenthesis | close parenthesis | dash | hyphen |underscore |
                                    question mark | exclamation mark | new line | new paragraph ;`;
              
                // Selección de gramática según idioma
                let lang =  this.$root.$options.i18n.locale
                const grammar =lang === 'es' ? grammarEs : grammarEn;

                this.speechRecognitionList = new SpeechGrammarList();
                this.speechRecognitionList.addFromString(grammar, 1);

                /// Asignar gramática y lenguaje
                this.recognition.grammars = this.speechRecognitionList;

            }
        },
        // Toggle the speech bar visibility
        toggleSpeechBar() {
            var speechBar = document.getElementById('speechBar');
            if(speechBar.classList.contains("active")){
                speechBar.classList.remove('active');
            } else {
                speechBar.classList.add('active');
            }
        },
        // Stop the speech to text recognition
        stopSpeechToText() {
            this.toggleSpeechBar()
            this.recognition.stop();
            this.recognizing = false;
            this.isSpeaking = false;
        },
        // Start the speech to text recognition
        startSpeechToText(control) {
            // Stop voice reconigtion if is on
            if( this.isSpeaking ) this.stopSpeech();

            if(this.isSpeechRecognitionSupported) {
                this.recognition.lang = this.$root.$options.i18n.locale;
                this.recognition.continuous = true;
                this.recognition.interimResults = true;
                this.recognition.maxAlternatives = 1;
                this.recognition.onend = () => {
                    if(this.recognizing) {
                        this.toggleSpeechBar()
                    }
                    this.recognizing = false;
                    this.isSpeaking = false;
                };
                this.recognition.onerror = (event) => {
                    console.error('Speech recognition error detected: ' + event.error);
                    this.recognizing = false;
                    this.isSpeaking = false;
                    this.toggleSpeechBar()
                };
                this.recognition.onresult = (event) => {
                    if (typeof event.results === "undefined") {
                        this.recognizing = false;
                        this.recognition.stop();
                        return;
                    }
                    var changed = {
                        "ControlId":control,
                        "finalSentence":''
                    }
                    
                    for (var i = event.resultIndex; i < event.results.length; ++i) {
                        if (event.results[i].isFinal) {
                            changed = {
                                "ControlId":control,
                                "finalSentence":event.results[i][0].transcript
                            }
                            changed.finalSentence = this.speechReplaceSpecialCharsAndCommands(changed.finalSentence)
                            changed.finalSentence = this.capitalizeAfterPunctuation(changed.finalSentence)
                            // Emit the event with the final sentence
                            EventBus.$emit('receivedS2T', changed);
                        }
                    }
                };
                if (!this.recognizing) {
                    this.recognition.start();
                    this.recognizing = true;
                } else {
                    this.recognition.stop();
                    this.recognizing = false;
                    this.isSpeaking = false;
                }
            }
        },

        // Start the speech synthesis
        startSpeech(speech) {
            console.log('speech', speech);
            if( speech.length > 0 ) {
                
                // Stop voice reconigtion if is on
                if( this.recognizing ) this.stopSpeechToText();
                
                if (speechSynthesis.speaking) {
                    // SpeechSyn is currently speaking, cancel the current utterance(s)
                    speechSynthesis.cancel();
                } else {
                    // Good to go
                    this.isSpeaking = true;
                    speech = this.speechReplaceSpecialCharsAndCommands(speech)
                    
                    var binding = new SpeechSynthesisUtterance(speech);
                    binding.lang = this.$root.$options.i18n.locale;
                    speechSynthesis.speak(binding);

                    binding.onend = () => {
                        if( this.isSpeaking) this.stopSpeech();
                    }
                }
            } else {
                this.stopSpeech();
            }
        },
        // Stop the speech synthesis
        // and reset the state
        stopSpeech() {
            this.isSpeaking = false;
            this.recognizing = false;
            // Stop voice reconigtion if is on
            this.toggleSpeechBar()
            // SpeechSyn is currently speaking, cancel the current utterance(s)
            speechSynthesis.cancel();
        },
        // Replace special characters in the speech text
        speechReplaceSpecialCharsAndCommands( speech) {
            let lang =  this.$root.$options.i18n.locale
            const rules = this.replacements[lang] || [];
            // speech = speech.replace(/&nbsp;/g, ' '); // Replace non-breaking spaces
            rules.forEach(rule => {
                speech = speech.replace(rule.regex, rule.value);
            });
            
            return speech;

        },
        capitalizeAfterPunctuation(text) {
            // Mayúscula al inicio del texto
            text = text.replace(/^\s*\w/, (c) => c.toUpperCase());
            // Mayúscula después de punto, exclamación, interrogación o salto de párrafo
            text = text.replace(/([.!?]\s+|\n\n\s*)(\w)/g, (match, sep, char) => sep + char.toUpperCase());
            // Mayúscula después de comillas
            return text;
        }
    },

    mounted(){
        if( !this.recognition ) { this.SpeechRecognition(); }
    },
    created() {
        this.$root.$refs.MdTextSpeech = this;
    },
  }
</script>